<template>
  <div ref="wrap">
    <div class="wrap">
      <div v-html="article.content"></div>
    </div>
    <div class="back" @click="toNew">返回新闻页查看更多</div>
    <div class="point">
      <h2>热门推荐</h2>
      <ul>
        <li v-for="(item,index) in pointList" :key="index">
          <div class="articleTitle">{{ item.title }}</div>
          <div class="clickDetail" @click="detail(item)">查看详情</div>
        </li>
      </ul>
    </div>
    <tips :flag="tipsFlag"></tips>
  </div>
</template>

<script>
  import {mapState} from 'vuex'
  import {get_news_list} from "../services/selectSide"
  import tips from '../components/tips'

  export default {
    name: "NewDetail",
    data() {
      return {
        pointList: [],
      }
    },
    components: {
      tips
    },
    computed: {
      ...mapState({
        article: state => state.article,
        tipsFlag: state => state.tipsFlag
      }),
    },
    mounted() {
      var content = {
        info_type: '-1',
        if_roll: '-1',
        if_point: '1',
        keyword: '-1',
        limit: '0',
        offset: '6'
      };
      get_news_list({content: JSON.stringify(content)}).then((res) => {
        if (res.code == 1) {
          this.pointList = res.data.info
          document.body.scrollTop = 0;
          document.documentElement.scrollTop = 0;
          // this.newCenter = res.data.info
        }
      })

    },
    methods: {
      toNew() {
        this.$router.replace('/News')
      },
      detail(item) {
        if (item.content) {
          this.$store.commit('setArticle', item)
          document.body.scrollTop = 0;
          document.documentElement.scrollTop = 0;
        } else {
          this.$store.commit('setTipsFlag', {tips: '当前文章没有详情', search_flag: true, tipsCode: 2});
        }

      }
    }
  }
</script>

<style scoped lang="scss">
  #tips {
    min-width: 200px;
    height: 50px;
    background: #666;
    position: fixed;
    top: 50%;
    left: 50%;
    margin-top: -25px;
    margin-left: -100px;
    z-index: 10000000;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 10px;
    padding: 0 10px;
    box-sizing: border-box;
    opacity: 1;
    transition: all 0.3s;

    p {
      font-size: 17px;
      color: #fff;
    }
  }

  #tips.no {
    opacity: 0;
  }

  .wrap {
    width: 80vh;
    /*height: 100%;*/
    margin: 90px auto;
    min-height: 60vh;
  }

  .point {
    width: 100%;
    padding-bottom: 20px;
    background: #F5F5F5;
    ul {
      width: 80vh;
      margin: 0 auto;
      li {
        display: block;
        width: 100%;
        height: 40px;
        line-height: 40px;
        .articleTitle {
          float: left;
          font-weight: bolder;
        }
        .clickDetail {
          cursor: pointer;
          float: right;
          color: $bg-color;
          font-weight: bolder;
        }

      }
    }
  }

  .point h2 {
    color: rgb(19, 19, 19);
    text-align: center;
    line-height: 60px;
  }

  .back {
    width: 80vh;
    margin: 0 auto;
    color: $bg-color;
    font-size: 20px;
    line-height: 80px;
    cursor: pointer;
  }
</style>



// WEBPACK FOOTER //
// src/view/NewDetail.vue